export default {"src":"/_next/static/media/thumbAvtar.8e27254e.svg","height":112,"width":111,"blurWidth":0,"blurHeight":0};